import React from 'react';
import { Flag } from 'flag';

import ProfessionalReviewsView from 'react/views/professionalReviews/ProfessionalReviewsView';
import CardContainer from './CardContainer';
import * as dataStore from 'data/DataStore';
import { getGroupedProfessionalReviews } from 'data/ProfessionalReviewSelector';
import { getPrimaryIsbn } from 'data/TitleInfoSelector';

const ProfessionalReviewsContainer = (props) => {
    const store = dataStore.getJsonData();
    const professionalReviewsCardModel = getGroupedProfessionalReviews(store);
    return (
		<Flag name="professionalReviews">
			<CardContainer
				cardName="Professional Reviews"
				cardModel = {professionalReviewsCardModel}
				component = {ProfessionalReviewsView}
				onItemClick={props.onItemClick}
				loggingId={getPrimaryIsbn(store)}
				{...props}
			/>
		</Flag>
    );
}

export default ProfessionalReviewsContainer;



// WEBPACK FOOTER //
// ./src/react/containers/ProfessionalReviewsContainer.jsx